<template>
  <div>
    <div layout="default">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'default',
  created () {
    this._loading()
  },
  methods: {
    async _loading () {
      window.onload = function () { }
    }
  }
}
</script>
